module.exports = __webpack_public_path__ + "img/button-home5.0761dddc.jpeg";